import moment from "moment";

/** Mirrors the pattern admin-mcp checks a date-time against before `OffsetDateTime.parse`. */
const ISO_OFFSET_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?(Z|[+-]\d{2}:\d{2})$/;
/** How a date-time is spelled on the wire: ISO-8601 with the offset, to the second. */
export const WIRE_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

/**
 * A date picker's model value as an ISO-8601 string with the browser's local offset — the
 * date-time the picker shows. Null when the picker holds nothing; undefined when the model holds
 * something other than epoch millis or a `Date`, which the bridge cannot represent.
 */
export function toIsoLocal(value: unknown): string | null | undefined {
  if (value == null) {
    return null;
  }
  if (typeof value !== "number" && !(value instanceof Date)) {
    return undefined;
  }
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format(WIRE_DATE_TIME_FORMAT) : undefined;
}

/** Epoch millis of an ISO-8601 date-time with offset, or undefined when the text is not one or names an impossible date. */
export function parseIsoOffset(text: string): number | undefined {
  if (!ISO_OFFSET_PATTERN.test(text)) {
    return undefined;
  }
  const parsed = moment(text, moment.ISO_8601, true);
  return parsed.isValid() ? parsed.valueOf() : undefined;
}

/** Tells the model which zone the offsets are in, so a value it sends lands on the local date the admin means. */
export function localTimeZoneHint(): string {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timeZone ? `ISO-8601 with offset; local time zone ${timeZone}` : "ISO-8601 with offset";
}
